import { useEffect, useState } from "react";
import { Block, BlockHeader, BlockTitle, List, ListItem, Navbar, Page, Preloader, Table, TableBody, TableCell, TableHead, TableRow } from "konsta/react";
import TabBar from "../components/TabBar";
import { useAppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { formatUSD } from "../utils";
import { useQuery } from "@tanstack/react-query";
import { fetchTopMiners, fetchTransactions } from "../clients/ApiClient";
import { TopMinerUser, UserTransaction } from "../models/Models";
import { UserTransactionTypeCd } from "../enums";
import moment from "moment";
import { GiLaurelsTrophy, GiTrophy, GiTrophyCup } from "react-icons/gi";
import { RiTrophyLine } from "react-icons/ri";

const TopMinersPage = () => {
    const {tgInitData} = useAppContext()
    const navigate = useNavigate()
    const [topMinerUsers, setTopMinerUsers] = useState<TopMinerUser[]>()

    const { data: topMiners, isLoading} = useQuery({
      queryKey: ["topMiners"],
      queryFn: fetchTopMiners,
      refetchInterval: 60 * (60 * 1000),
      enabled: tgInitData !== undefined
    });

    useEffect(() => {
      if (topMiners) {        
        setTopMinerUsers(topMiners)
      }
    }, [topMiners])

    return (
      <Page className="select-none pb-40">
        <Navbar
            title="Top Miners"
            className="top-0 sticky translucent "
            left={<FaArrowLeftLong className="mx-3 w-5 h-5" onClick={() => navigate(-1)}/>}
          />
        
        <img src="/images/rank.svg" />

        {isLoading && <Block className="text-center">
          <Preloader />
        </Block>}

        {topMinerUsers && <>
          <Block className="text-center">
            This list is updated every 24 hours
          </Block>
          <div className="">
            <List strong>
              {topMinerUsers.map((t, index) => {
                const rank = index + 1;
                const rankColor = rank === 1 ? 'text-yellow-500 w-5 h-5' : rank === 2 ? 'text-indigo-500 w-5 h-5' :  rank === 3 ? 'text-pink-500 w-5 h-5' : ''
                const incomeColor = rank === 1 ? 'text-yellow-500' : rank === 2 ? 'text-indigo-500' :  rank === 3 ? 'text-pink-500' : 'text-primary'
                return <ListItem 
                media={rank === 1 ? <GiLaurelsTrophy className={rankColor} /> : rank === 2 ? <GiTrophy className={rankColor}/> : rank === 3 ? <GiTrophyCup className={rankColor}/> : <RiTrophyLine />}
                title={<span className="font-bold">{t.username}</span>}
                footer={`owns ${t.productcount} miners`}
                after={<div className="flex flex-col">
                  <span className={`text-lg ${incomeColor} font-bold`}>{formatUSD(t.totalprofit)}</span>
                  <span className="text-xs font-semibold">per day</span>
                  
                </div>}
              />
              })}
            </List>
          </div>
        </>}
        <TabBar selectedTab="profile"/>
      </Page>
    );
  };
  
  export default TopMinersPage;
  